// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__+MTT5","content":"style_content__bm8bq"};